<form>
  <div class="d-flex flex-wrap gap-1 border mt-1 p-1 position-relative">

    <small class="text-muted fst-italic position-absolute bg-white px-1"
      style="font-size: .65rem; opacity: .7; top: -.55rem; right: .5rem;">Calculated per unit</small>


    <div class="uic-type-field">
      <label class="form-check-label">Type</label>
      <select class="form-select form-select-sm" name="taxType" [(ngModel)]="taxType" (change)="updateTaxPerc()">
        <option *ngFor="let list of taxDropdownList" value="{{+list.key}}">{{list.value}}</option>
      </select>
    </div>

    <div class="uic-other-field">
      <label class="form-check-label">Tax. %</label>
      <input id="taxNumber" type="number" class="form-control form-control-sm" name="taxValue"
        [(ngModel)]="taxValue" (ngModelChange)="calculateTax()" readonly />
    </div>

    <div class="uic-other-field">
      <label class="form-check-label">Tax. Amt</label>
      <input type="number" class="form-control form-control-sm" [formControl]="getFormControl('tax')" readonly />
    </div>

    <div class="uic-other-field">
      <label class="form-check-label">Final Price</label>
      <input type="number" class="form-control form-control-sm" name="totalAmount" [(ngModel)]="totalAmount" readonly />
    </div>

  </div>
</form>
